module.exports = __webpack_public_path__ + "static/media/IPMI_LOGO-Reversed_Large-R_1739381489322.a2851ad0.png";